import React, { useEffect, useReducer, useRef } from 'react';
import {
    Inject, ScheduleComponent, Day, Week, WorkWeek,
    Month, Agenda, DragAndDrop, Resize
} from '@syncfusion/ej2-react-schedule';
import API from '../Network/API';
import { applyCategoryColor } from './helper';
import { initialState, reducer } from './reducer';
import { getActiveSprints, getEvent } from './Services/getEvent';
import { getEmployees } from './Services/getEmployees';
import { getModules } from './Services/getModules';
import { getToDo } from './Services/getToDo';
import { getSprint } from './Services/getSprint';
import Header from '../TopNav';
import AdminSideBar from '../../UserModule/Utility/SideNav';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { isLoaded, isLoading } from '../Actions/loading';
import Alert from '../Alert';
import { MultiSelect } from '@syncfusion/ej2-dropdowns';
import { createElement, L10n } from '@syncfusion/ej2-base';
import { Query, DataManager } from '@syncfusion/ej2-data';
import { GridComponent } from '@syncfusion/ej2-react-grids';
import "./calendar.css"
import RootLoader from '../Loader/RootLoader';
import { Client_URL, Meet_URL, Reports_URL } from '../config';
import { useWebProperties } from '../webProperties';
import { getGroup } from '../TasksModals/Services/getGroup';
import { tasksReducer, initialState as initialGroupData } from '../TasksModals/tasksReducer';
import { getMachineTimeZONE, removeDuplicatesFromString, removeSpecialCharacters } from '../commonUsage';
import { getProjects } from '../TasksModals/Services/getProjects';
import { createCalendarTask } from './Services/createCalendarTask';
import { createCalendargroupTask } from './Services/createCalendarGroupTask';
import moment from 'moment';
import { isFetch, isFetched } from './action';
import { addCommentUserStory } from '../../UserModule/Modules/Services/addCommentUserStory';
import { getSubStringId } from '../SubStringConvert';
import jwt from 'jsonwebtoken';
import { updateUserStory } from '../../UserModule/ConsolidatedToDo/Services/updateUserStory';
import { logEntry } from '../logEntry';
import { addDays, addWeeks, addMonths, addYears } from 'date-fns';
import Axios from 'axios';

L10n.load({
    'en-US': {
        'schedule': {
            'editSeries': '',
            'deleteSeries': '',
            'editFollowingEvent': 'Following Events',
        },
    }
});


function Calender() {

    // eslint-disable-next-line
    const [state, dispatch] = useReducer(reducer, initialState);
    const { APP_NAME, URL, MAINTASK_ADD, MAINTASK, MODULE, TASKS_WARNING, ROADBLOCK_WARNING } = useWebProperties();
    const getUser = useSelector(state => state.auth)
    const [state1, dispatch1] = useReducer(tasksReducer, initialGroupData);
    const activities = useSelector(state => state.landingReducer.userActivities)
    const scheduleObj = useRef(null);
    useEffect(() => {
        const fetchData = async () => {
            await getEmployees(dispatch, getUser.user);
            await getEvent(getUser.user, dispatch, APP_NAME, activities);
            await getModules(dispatch, getUser.user);
            await getSprint(dispatch, getUser.user);
            await getGroup(dispatch1, getUser.user);
            await getProjects(dispatch1, getUser.user);
            await getActiveSprints(dispatch, getUser.user)
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const updateTaskMeetingUrl = async (employe) => {
        const secretKey = "RALLYWETASKER";

        // Sample payload data
        const payload = {
            "context": {
                "user": {
                    "avatar": "",
                    "name": "",
                    "email": "",
                },
            },
            "aud": "jitsi",
            "iss": "23456789",
            "sub": Meet_URL,
            "room": removeSpecialCharacters(`${getSubStringId(employe[0].name, 2)}-${employe[0].u_id}`),
            // "exp": 1700060038,
        };
        const generatedToken = jwt.sign(payload, secretKey);
        const meeting_url = `https://${Meet_URL}/${removeSpecialCharacters(`${getSubStringId(employe[0].name, 2)}-${employe[0].u_id}`)}?jwt=${generatedToken}#jitsi_meet_external_api_id=98765432&config.startWithAudioMuted=true&config.startWithVideoMuted=true&config.autoCaptionOnRecord=true`
        try {
            // eslint-disable-next-line
            const response = await API.post("manage_userstories.php", {
                action: "updateMeetingUserURL",
                us_id: employe[0].u_id,
                meeting_url: meeting_url
            }, {}, false);
            if (response.status === "True") {
                return response.meeting_url
            } else {
                return ""
            }
        } catch (error) {
            console.log(error)
        }
    }
    // for add validation to the fields
    const fields = {
        subject: { name: 'Subject', validation: { required: true } },
        startTime: { name: 'StartTime', validation: { required: true } },
        endTime: { name: 'EndTime', validation: { required: true } },
        description: { name: 'Description' },
    };
    var sprints = []
    state.modules.map((module) => {
        return (
            sprints.push({
                'value': module.moduleId, 'label': module.moduleDesc, assignbyId: module.assignbyId,
                average: module.average,
                createdBy: module.createdBy,
                created_on: module.created_on,
                ideaId: module.ideaId,
                ideaTitle: module.ideaTitle,
                moduleDesc: module.moduleDesc,
                moduleId: module.moduleId,
                startDate: module.startDate,
                status: module.status,
                targetDate: module.targetDate
            })
        );
    })
    var stories = []
    // user stories to display on calendar
    const getSection = state.section.filter(item => item.assigned_by === getUser.user.empId || item.assigned_to === getUser.user.empId)
    getSection.map((story) => {
        return (
            stories.push({
                Subject: story.story_title,
                EndTime: story.target_date,
                StartTime: story.target_date,
                // make it all day event to display it on top of calendar
                IsAllDay: "1",
                IsReadonly: "1",
                Color: '#df5286',
                Members: story.assignedto,
                Location: story.active_status === "0" ? "To Do"
                    : story.active_status === "1" ? "In Progress"
                        : story.active_status === "-1" ? "Blocked" : "Completed"
            })
        );
    })

    var employeeData = state.employees = state.employees.map(employee => {
        return { ...employee, from: 'user' };
    })

    const deleteTask = (taskToDelete, addedEmp) => {
        const tasks = employeeData.filter(task => task.email !== taskToDelete);
        // eslint-disable-next-line
        tasks.unshift(addedEmp)
        return { tasks };
    }
    const employeeDetails = deleteTask(getUser.user.userName, {
        id: getUser.user.empId, name: getUser.user.fullName,
        email: getUser.user.userName, userName: getUser.user.userName, role: getUser.user.role, empStatus: getUser.user.empStatus, from: "user",
    })

    employeeData = getUser.user.role === 'Limited Access Contributor' ? [{
        id: getUser.user.empId, name: getUser.user.fullName,
        email: getUser.user.userName, userName: getUser.user.userName, role: getUser.user.role, empStatus: getUser.user.empStatus, from: "user",
    }] : employeeDetails.tasks.filter(user => user.name !== "" && user.email !== null)

    var groupData = getUser.user.role === 'Limited Access Contributor' ? [] : state1.groups.map(groups => {
        return {
            ...groups, from: 'group', email: groups.id, name: `${groups.group_name}-[${removeDuplicatesFromString(groups.members_name)}]`
        };
    })

    var combinedEmpArray = [...employeeData, ...groupData]

    let recurrenceLoading = false
    let isGroupTask = false
    let groupNumber

    const getDate = async (data) => {
        let newDate = new Date(data?.StartTime);
        let day = newDate.getDate();
        let month = newDate.getMonth();
        let year = newDate.getFullYear();

        return (`${year}-${month + 1}-${day}`);
    }

    const checkBetween = async (date) => {
        let startDate = new Date(state.activeSprint.startDate);
        let endDate = new Date(state.activeSprint.targetDate);
        let checkDate = new Date(date);

        if (checkDate >= startDate && checkDate <= endDate) {
            return true
        } else {
            return false
        }
    }

    const validateDate = async (data) => {
        let startDate = new Date();
        let checkDate = new Date(data);

        if (checkDate >= startDate) {
            return true
        } else {
            return false
        }
    }

    const modifyDates = async (data) => {
        const start = new Date(data.StartTime);
        const end = new Date(data.EndTime);
        const startDate = `${start.getMonth() + 1}/${start.getDate()}/${start.getFullYear().toString().slice(-2)} ${start.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
        const endDate = `${end.getMonth() + 1}/${end.getDate()}/${end.getFullYear().toString().slice(-2)} ${end.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
        const estimateTime = (end - start) / (1000 * 60)
        const targetTime = Math.ceil(estimateTime / 60)
        return { startDate, endDate, targetTime }
    }

    const getRecurrenceValues = async (rule) => {
        const parts = rule.split(';'); // Split the rule by each attribute
        const values = {}; // Object to hold FREQ and UNTIL values

        parts.forEach(part => {
            const [key, value] = part.split('='); // Separate each attribute's key and value
            values[key] = value;
        });

        return values;
    };

    const generateRecurringEvents = async (startTime3, repeatStatus, repeatCount, untilDate, recurrenceValues) => {
        let dates = [];
        let currentDate = new Date(startTime3);
        const compareDate = new Date(startTime3);
        let occurrences = 0;
        let daysOfWeek
        let weekOfMonth
        if (recurrenceValues.BYDAY) {
            const daysString = recurrenceValues.BYDAY;
            daysOfWeek = daysString.split(",");
        }
        if (recurrenceValues.BYSETPOS) {
            weekOfMonth = recurrenceValues.BYSETPOS
        }

        const getDayCount = (day) => {
            switch (day) {
                case 'SU':
                    return 0
                case 'MO':
                    return 1
                case 'TU':
                    return 2
                case 'WE':
                    return 3
                case 'TH':
                    return 4
                case 'FR':
                    return 5
                case 'SA':
                    return 6
                default:
                    return null;
            }
        }

        const incrementFunction = {
            DAILY: (date) => addDays(date, 1),   // for DAILY frequency, increment by 1 day
            WEEKLY: (date) => addWeeks(date, 1),  // for WEEKLY frequency, increment by 1 week
            MONTHLY: (date) => addMonths(date, 1), // for MONTHLY frequency, increment by 1 month
            YEARLY: (date) => addYears(date, 1)   // for YEARLY frequency, increment by 1 year
        }[repeatStatus];

        const untilDateString = untilDate
        let formattedUntilDateString
        if (untilDateString) {
            formattedUntilDateString = untilDateString.replace(
                /(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})(Z)/,
                '$1-$2-$3T$4:$5:$6$7'
            );
        }
        const untilDateObj = formattedUntilDateString ? new Date(formattedUntilDateString) : null

        const addWeeklyOccurrences = (baseDate) => {
            daysOfWeek.forEach(day => {
                const dayCount = getDayCount(day);
                const nextOccurrence = new Date(baseDate);
                if (dayCount < baseDate.getDay()) {
                    nextOccurrence.setDate(baseDate.getDate() - (baseDate.getDay() - dayCount));
                } else {
                    nextOccurrence.setDate(baseDate.getDate() + ((dayCount - baseDate.getDay() + 7) % 7));
                }

                if ((!untilDateObj || nextOccurrence <= untilDateObj) && (!repeatCount || occurrences < repeatCount)) {
                    dates.push(new Date(nextOccurrence));  // Add a new Date instance to avoid reference issues
                }
            })
        }

        // Generate dates based on COUNT or UNTIL date
        while ((repeatCount && occurrences < repeatCount) || (untilDateObj && currentDate <= untilDateObj)) {
            switch (repeatStatus) {
                case 'DAILY':
                    dates.push(currentDate);
                    currentDate = incrementFunction(currentDate);
                    occurrences++;
                    break;
                case 'WEEKLY':
                    addWeeklyOccurrences(currentDate)
                    occurrences++;
                    currentDate = incrementFunction(new Date(currentDate));
                    break;
                case 'MONTHLY':
                    if (recurrenceValues.BYMONTHDAY) {
                        const nextOccurrence = new Date(currentDate);
                        nextOccurrence.setDate(recurrenceValues.BYMONTHDAY);
                        if ((!untilDateObj || nextOccurrence <= untilDateObj) && (!repeatCount || occurrences < repeatCount)) {
                            dates.push(new Date(nextOccurrence));
                            if (new Date(nextOccurrence) >= compareDate) {
                                occurrences++;
                            }
                        }
                    } else {
                        const nextOccurrence = new Date(currentDate);
                        const dayCount = getDayCount(daysOfWeek[0]);
                        nextOccurrence.setDate(1);
                        const firstDay = nextOccurrence.getDay();
                        const offset = (dayCount - firstDay + 7) % 7 + (weekOfMonth - 1) * 7;
                        nextOccurrence.setDate(1 + offset);
                        if ((!untilDateObj || nextOccurrence <= untilDateObj) && (!repeatCount || occurrences < repeatCount)) {
                            dates.push(new Date(nextOccurrence));
                            if (new Date(nextOccurrence) >= compareDate) {
                                occurrences++;
                            };
                        }
                    }
                    currentDate = incrementFunction(currentDate);
                    break;
                case 'YEARLY':
                    if (recurrenceValues.BYMONTHDAY) {
                        const nextOccurrence = new Date(currentDate);
                        nextOccurrence.setMonth(recurrenceValues.BYMONTH - 1)
                        nextOccurrence.setDate(recurrenceValues.BYMONTHDAY);
                        if ((!untilDateObj || nextOccurrence <= untilDateObj) && (!repeatCount || occurrences < repeatCount)) {
                            dates.push(new Date(nextOccurrence));
                            if (new Date(nextOccurrence) >= compareDate) {
                                occurrences++;
                            };
                        }
                    } else {
                        const nextOccurrence = new Date(currentDate);
                        nextOccurrence.setMonth(recurrenceValues.BYMONTH - 1)
                        const dayCount = getDayCount(daysOfWeek[0]);
                        nextOccurrence.setDate(1);
                        const firstDay = nextOccurrence.getDay();
                        const offset = (dayCount - firstDay + 7) % 7 + (weekOfMonth - 1) * 7;
                        nextOccurrence.setDate(1 + offset);
                        if ((!untilDateObj || nextOccurrence <= untilDateObj) && (!repeatCount || occurrences < repeatCount)) {
                            dates.push(new Date(nextOccurrence));
                            if (new Date(nextOccurrence) >= compareDate) {
                                occurrences++;
                            };
                        }
                    }
                    currentDate = incrementFunction(currentDate);
                    break;

                default:
                    break;
            }
        }

        return dates;
    };

    const checkRecurringEvents = async (data) => {
        recurrenceLoading = true
        const start = new Date(data.StartTime)
        const end = new Date(data.EndTime)
        const difference = end.getTime() - start.getTime()
        const recurrenceValues = await getRecurrenceValues(data.RecurrenceRule)
        const recurringGroups = groupData
        const recurringUsers = employeeData
        let recurrenceDates
        if (recurrenceValues.COUNT) {
            recurrenceDates = await generateRecurringEvents(data.StartTime, recurrenceValues.FREQ, recurrenceValues.COUNT, recurrenceValues.UNTIL, recurrenceValues)
        } else if (recurrenceValues.UNTIL) {
            recurrenceDates = await generateRecurringEvents(data.StartTime, recurrenceValues.FREQ, null, recurrenceValues.UNTIL, recurrenceValues)
        } else {
            Alert("error", "Please select either the 'until' or 'count' option in the repeat end field.")
            await getEvent(getUser.user, dispatch, APP_NAME, activities)
            recurrenceLoading = false
            dispatch(isFetched());
            dispatch(isLoaded());
            return
        }

        for (const item of recurrenceDates) {
            const date = new Date(item);
            const newDate = new Date(date.getTime() + difference);
            const endingTime = newDate;
            groupData = recurringGroups
            employeeData = recurringUsers
            data.RecurrenceRule = null
            data.StartTime = item
            data.EndTime = endingTime
            await createEvent(data)
        }
        recurrenceLoading = false
        groupNumber = ''
        isGroupTask = false
        await getEvent(getUser.user, dispatch, APP_NAME, activities)
        dispatch(isFetched());
        dispatch(isLoaded());
    }

    const decodeHtmlEntity = (encodedStr) => {
        var doc = new DOMParser().parseFromString(encodedStr, 'text/html');
        return doc.documentElement.textContent;
    }
    const createEvent = async (data) => {
        data.Subject = decodeHtmlEntity(data.Subject)
        data.Description = decodeHtmlEntity(data.Description)
        let value
        if (isGroupTask) {
            value = groupNumber
        } else {
            value = data.Members[0]
        }
        const changeDate = await modifyDates(data)
        let assignee
        let eventType = "user"
        if (!isNaN(parseInt(value))) {
            groupNumber = value
            isGroupTask = true
            assignee = groupData.filter((item) => item.id === value)
            const selectedMembers = (assignee[0].members_email).split(",").filter(email => email !== '')
            data.Members = selectedMembers
            eventType = "group"
        }
        dispatch(isLoading());
        try {
            const start_time = Date.now()
            // eslint-disable-next-line
            var response = await API.post("calendar.php", {
                urlBase: urlBase,
                addEvent: data,
                corp_code: getUser.user.corp,
                action: "Add",
                emp_id: getUser.user.empId,
                projectId: getUser.user.projectId,
                fullName: getUser.user.fullName,
                userName: getUser.user.userName,
                url: Client_URL,
                appName: APP_NAME,
                start_time: changeDate.startDate,
                end_time: changeDate.endDate,
                event_type: eventType,
                created_time_zone: getMachineTimeZONE()
            }, {}, false);
            const end_time = Date.now()
            if (response.status === "True") {
                dispatch(isLoaded());
                if (true) {
                    await createTask(data, assignee, response.event_id, changeDate.targetTime);
                } else {
                    await getEvent(getUser.user, dispatch, APP_NAME, activities)
                    dispatch(isFetched());
                }
                activities && logEntry({
                    user_id: getUser.user.userName, logging_level: 3,
                    activity_id: activities["Calendar"], sub_activity: "Create Event", response_time: (end_time - start_time)
                }, getUser)
            }
            else {
                console.log("Something went wrong")
                await getEvent(getUser.user, dispatch, APP_NAME, activities)
                dispatch(isLoaded());
                dispatch(isFetched());
                activities && logEntry({
                    user_id: getUser.user.userName, logging_level: 2,
                    activity_id: activities["Calendar"], sub_activity: "Create Event"
                }, getUser)
            }
        } catch (error) {
            Alert('error', error.message);
            await getEvent(getUser.user, dispatch, APP_NAME, activities)
            dispatch(isLoaded());
            dispatch(isFetched());
            activities && logEntry({
                user_id: getUser.user.userName, logging_level: 2,
                activity_id: activities["Calendar"], sub_activity: "Create Event",
                error_message: error.message
            }, getUser)
        }
    }

    const createTask = async (data, assignee, eventId, targetTime) => {
        dispatch(isLoading());
        try {
            const date = await getDate(data);
            const inBetween = await checkBetween(date)
            const sprintDesc = state.modules[0].moduleDesc

            let epicId = ""
            if (state1.projects.length > 0) {
                const userEpic = state1.projects.filter((epic) => epic.idea_title === "Default Module")
                epicId = userEpic[0].id
            }
            let selectedMembers = []
            if (assignee !== undefined) {
                const details = {
                    taskTitle: { value: data.Subject },
                    taskDescription: { value: data.Description },
                    userSelected: { value: assignee[0].id, label: assignee[0].name, from: assignee[0].from, members_email: assignee[0].members_email },
                    acceptanceCriteria: { value: data.Description },
                    storySelected: targetTime,
                    prioritySelected: "",
                    epicSelected: epicId,
                    player_id: "",
                    moduleId: inBetween ? state.modules[0]?.moduleId : null,
                    targetDate: moment(data?.StartTime).format('YYYY-MM-DD'),
                    eventId: eventId,
                    from_screen: "calendar",
                    projectId: getUser.user.projectId,
                    corp: getUser.user.corp,
                    location: data.Location,
                }
                await createCalendargroupTask(activities, details, dispatch, getUser.user, MAINTASK_ADD, MAINTASK, MODULE, sprintDesc)
                if (!recurrenceLoading) {
                    groupNumber = ''
                    isGroupTask = false
                    await getEvent(getUser.user, dispatch, APP_NAME, activities)
                    dispatch(isLoaded());
                    dispatch(isFetched());
                }
            } else {
                selectedMembers = data.Members
                await selectedMembers.forEach((item) => {
                    const user = employeeData.filter((userList) => userList.email === item)
                    const details = {
                        taskTitle: { value: data.Subject },
                        taskDescription: { value: data.Description },
                        userSelected: { value: user[0].id, label: user[0].name, from: user[0].from, email: user[0].email },
                        acceptanceCriteria: { value: data.Description },
                        storySelected: targetTime,
                        prioritySelected: "",
                        epicSelected: epicId,
                        player_id: "",
                        moduleId: inBetween ? state.modules[0]?.moduleId : null,
                        targetDate: moment(data.StartTime).format('YYYY-MM-DD'),
                        eventId: eventId,
                        projectId: getUser.user.projectId,
                        corp: getUser.user.corp,
                        from_screen: "calendar",
                        location: data.Location,
                    }
                    createCalendarTask(activities, details, dispatch, getUser.user, MAINTASK, MODULE, sprintDesc)
                })
                if (!recurrenceLoading) {
                    await getEvent(getUser.user, dispatch, APP_NAME, activities)
                    dispatch(isLoaded());
                    dispatch(isFetched());
                }
            }
        } catch (error) {
            console.error('Error creating task:', error);
            await getEvent(getUser.user, dispatch, APP_NAME)
            dispatch(isLoaded());
            dispatch(isFetched());
        }
    }

    const urlBase = `${URL}calendarPathSetUp?key=${getUser.user.corp}&projectId=${getUser.user.projectId}&empId=`;

    const modifyEvent = async (updateObj, prevObj) => {
        dispatch(isFetch());
        const date = await getDate(updateObj)
        const inBetween = await checkBetween(date)
        const changeDate = await modifyDates(updateObj)
        try {
            const start_time = Date.now()
            // eslint-disable-next-line
            var response = await API.post("calendar.php", {
                urlBase: urlBase,
                action: "InsertUpdate",
                corp_code: getUser.user.corp,
                current: updateObj,
                projectId: getUser.user.projectId,
                fullName: getUser.user.fullName,
                userName: getUser.user.userName,
                url: Client_URL,
                appName: APP_NAME,
                target_date: moment(updateObj?.StartTime).format('YYYY-MM-DD'),
                start_time: changeDate.startDate,
                end_time: changeDate.endDate,
                module_id: inBetween ? state.modules[0]?.moduleId : null,
                created_time_zone: getMachineTimeZONE(),
                story_points: changeDate.targetTime,
                "acknowledge": JSON.stringify(prevObj?.acknowledge),
            }, {}, false);
            const end_time = Date.now()
            await getEvent(getUser.user, dispatch, APP_NAME, activities);
            dispatch(isFetched())
            activities && logEntry({
                user_id: getUser.user.userName, logging_level: 3,
                activity_id: activities["Calendar"], sub_activity: "Modify Event", response_time: (end_time - start_time)
            }, getUser)
        } catch (error) {
            await getEvent(getUser.user, dispatch, APP_NAME);
            Alert('error', error.message);
            dispatch(isFetched())
            activities && logEntry({
                user_id: getUser.user.userName, logging_level: 2,
                activity_id: activities["Calendar"], sub_activity: "Modify Event",
                error_message: error.message
            }, getUser)
        }
    }

    // for handling operations performed by calendar like add, delete, edit, resize, drag and drop 
    const handleData = async (e) => {
        const data = e.result
        const length = e.result.length
        dispatch(isLoading());
        if (scheduleObj.current.currentAction === "Delete" || scheduleObj.current.currentAction === "DeleteSeries") {
            const currentAction = scheduleObj.current.currentAction
            const object = scheduleObj.current.activeEventData.event
            if (object?.emp_id === getUser.user.empId) {
                dispatch(isFetch())
                try {
                    const start_time = Date.now()
                    // eslint-disable-next-line
                    var response = await API.post("calendar.php", {
                        urlBase: urlBase,
                        action: currentAction,
                        current: object,
                        corp_code: getUser.user.corp,
                        projectId: object.ProjectName,
                        fullName: getUser.user.fullName,
                        userName: getUser.user.userName,
                        url: Client_URL,
                        appName: APP_NAME,

                    }, {}, false);
                    const end_time = Date.now()
                    if (response.status === "True" && response.task_details.length > 0) {
                        await response?.task_details?.forEach(item => {
                            if (item.active_status === "1") {
                                let data = { task_id: item.task_id, story_id: item.story_id, task_type: item.task_type, project_name: item.project_name, main_task_id: item.main_task_id, story_type: item.story_type, us_id: item.us_id, story_title: item.story_title, blocked_id: item.blocked_id, userStoryId: item.userStoryId, calendarId: item?.calendar_id };
                                let message = `This meeting, ${MAINTASK} is completed`;
                                updateUserStory(activities, getUser.user, data.story_id, "handleClose", message, TASKS_WARNING, ROADBLOCK_WARNING, data.story_type, data.us_id, data.main_task_id, MAINTASK, data.calendarId)
                            }
                        })
                        dispatch(isLoaded())
                    }
                    await getEvent(getUser.user, dispatch, APP_NAME, activities);
                    dispatch(isFetched())
                    activities && logEntry({
                        user_id: getUser.user.userName, logging_level: 3,
                        activity_id: activities["Calendar"], sub_activity: "Delete Event", response_time: (end_time - start_time)
                    }, getUser)
                } catch (error) {
                    console.log(error)
                    Alert('error', error.message);
                    dispatch(isLoaded())
                    dispatch(isFetched())
                    activities && logEntry({
                        user_id: getUser.user.userName, logging_level: 2,
                        activity_id: activities["Calendar"], sub_activity: "Delete Event",
                        error_message: error.message
                    }, getUser)
                }
            } else {
                if (object?.emp_id !== undefined) {
                    Alert("warning", "You are not authorized to delete this event")
                    await getEvent(getUser.user, dispatch, APP_NAME, activities);
                    dispatch(isLoaded())
                    activities && logEntry({
                        user_id: getUser.user.userName, logging_level: 2,
                        activity_id: activities["Calendar"], sub_activity: "Delete Event",
                        error_message: "You are not authorized to delete this event"
                    }, getUser)
                }
            }
        } else if (scheduleObj.current.currentAction === "Add" && scheduleObj.current.activeEventData.event === undefined) {
            dispatch(isLoading())
            //const validate = await validateDate(e.result[length - 1].StartTime)
            //if (validate) {
            if (e.result[length - 1]?.Members.length > 0 && e.result[length - 1]?.Subject.trim() !== "") {
                if (e.result[length - 1].Members.length > 1 && !(e.result[length - 1].Members.every(item => isNaN(item)))) {
                    Alert("error", "Please select only users or only one group")
                    dispatch(isLoaded());
                    await getEvent(getUser.user, dispatch, APP_NAME, activities);
                } else {
                    if (!e.result[length - 1].Description) {
                        e.result[length - 1].Description = e.result[length - 1].Subject
                    } else {
                        if (e.result[length - 1].Description.trim() === "") {
                            e.result[length - 1].Description = e.result[length - 1].Subject
                        }
                    }
                    dispatch(isFetch());
                    if (e.result[length - 1].RecurrenceRule !== null) {
                        await checkRecurringEvents(e.result[length - 1]);
                    } else {
                        await createEvent(e.result[length - 1]);
                    }
                }
            } else {
                if (e.result[length - 1]?.Subject.trim() === "" || e.result[length - 1]?.Description.trim() === "") {
                    Alert("error", "Please fill both the title and description fields and ensure they are not empty.")
                    await getEvent(getUser.user, dispatch, APP_NAME, activities);
                    dispatch(isLoaded());
                } else {
                    Alert("error", "Please select Attendees")
                    await getEvent(getUser.user, dispatch, APP_NAME, activities);
                    dispatch(isLoaded());
                }
            }
            // } else {
            //     if (e.result[length - 1].Id !== undefined) {
            //         Alert("warning", "Please select a date and time that are not in the past")
            //         dispatch(isLoaded());
            //         await getEvent(getUser.user, dispatch, APP_NAME,activities);
            //     }
            // }
        } else if (scheduleObj.current.currentAction === "EditOccurrence") {
            try {
                // eslint-disable-next-line
                var response = await API.post("calendar.php", {
                    urlBase: urlBase,
                    addEvent: e.result[length - 1],
                    corp_code: getUser.user.corp,
                    data: data,
                    action: scheduleObj.current.currentAction,
                    projectId: getUser.user.projectId,
                    fullName: getUser.user.fullName,
                    userName: getUser.user.userName,
                    url: Client_URL,
                    appName: APP_NAME,
                }, {}, false);
                if (response.status === "True") {
                }
            } catch (error) {
                console.log(error)
                Alert('error', error.message);
            }
        } else if (scheduleObj.current.currentAction === 'EditFollowingEvents') {
            try {
                // eslint-disable-next-line
                var response = await API.post("calendar.php", {
                    urlBase: urlBase,
                    data: data,
                    addEvent: e.result[length - 1],
                    current: scheduleObj.current.activeEventData.event,
                    action: scheduleObj.current.currentAction,
                    corp_code: getUser.user.corp,
                    projectId: getUser.user.projectId,
                    fullName: getUser.user.fullName,
                    userName: getUser.user.userName,
                    url: Client_URL,
                    appName: APP_NAME,
                }, {}, false);
            } catch (error) {
                console.log(error)
                Alert('error', error.message);
            }
        } else {
            const prevObj = scheduleObj.current.activeEventData.event
            const object = data?.filter(item => item.Id === prevObj?.Id)
            let updateObj
            let eventId
            let assignee
            if (object[0]?.Id !== undefined) {
                updateObj = object[0]
                eventId = object[0]?.Id
            }
            let validate
            let changeDate
            if (updateObj !== undefined) {
                validate = await validateDate(updateObj.EndTime)
                changeDate = await modifyDates(updateObj)
            }
            if (prevObj?.emp_id === getUser.user.empId && validate) {
                const addMembers = updateObj?.Members?.filter(item => !prevObj?.Members.includes(item))
                const deleteMembers = prevObj?.Members?.filter(item => !updateObj?.Members.includes(item))
                if (prevObj?.story_type === "group" || prevObj?.event_type === "group") {
                    if (addMembers?.length > 0 || deleteMembers?.length > 0) {
                        Alert("warning", "This is a Group Event. You cannot add or remove users for this event.")
                        await getEvent(getUser.user, dispatch, APP_NAME, activities);
                    } else {
                        await modifyEvent(updateObj, prevObj)
                    }
                } else {
                    if (deleteMembers?.length > 0) {
                        await deleteMembers.forEach((item) => {
                            const user = employeeData.filter((userList) => userList.email === item)
                            var response = API.post("calendar.php", {
                                urlBase: urlBase,
                                data: data,
                                action: "RemoveEmpEventTasks",
                                assigned_to: user[0].id,
                                corp_code: getUser.user.corp,
                                state: scheduleObj.current.currentAction,
                                current: scheduleObj.current.activeEventData.event,
                                projectId: getUser.user.projectId,
                                fullName: getUser.user.fullName,
                                userName: getUser.user.userName,
                                url: Client_URL,
                                appName: APP_NAME,
                            }, {}, false);
                            response.then(result => {
                                if (result.status === "True" && result?.task_details?.length > 0) {
                                    const deleteTask = result?.task_details?.filter(task => task.assigned_to === user[0].id)
                                    const message = `${MAINTASK} is completed`
                                    addCommentUserStory(dispatch, getUser.user, deleteTask[0].story_id, message, "11");
                                }
                            })
                        })
                    }
                    if (addMembers?.length > 0) {
                        if (!(addMembers.every(item => isNaN(item)))) {
                            Alert("error", "Please select only users")
                            dispatch(isLoaded());
                            await getEvent(getUser.user, dispatch, APP_NAME, activities);
                        } else {
                            const details = {
                                Subject: updateObj.Subject,
                                Description: updateObj.Description,
                                StartTime: updateObj?.StartTime,
                                Members: addMembers,
                                Location: updateObj.Location
                            }
                            await modifyEvent(updateObj, prevObj)
                            await createTask(details, assignee, eventId, changeDate.targetTime)
                            dispatch(isLoaded());
                        }
                    } else {
                        await modifyEvent(updateObj, prevObj)
                    }
                }

                dispatch(isLoaded());
            } else {
                if (!validate && prevObj?.emp_id !== undefined) {
                    Alert("warning", "Please select a date and time that are not in the past")
                    await getEvent(getUser.user, dispatch, APP_NAME, activities);
                }
                else if (prevObj?.emp_id !== undefined) {
                    Alert("warning", "You are not authorized to modify this event")
                    await getEvent(getUser.user, dispatch, APP_NAME, activities);
                }
                dispatch(isLoaded());
            }
            dispatch(isLoaded());
        }
    }

    const submitResponse = async ({ eventId, acknowledgeData, response, reason }) => {
        let userReason = null
        if (reason) {
            userReason = reason
        }
        const updateUser = acknowledgeData.map(user => {
            if (user.email === getUser.user.userName) {
                return { email: user.email, ackStatus: response, reason: userReason }
            } else {
                return { email: user.email, ackStatus: user.ackStatus, reason: user.reason }
            }
        })
        try {
            await Axios.post(`${Reports_URL}/calender/calAck`, {
                "acknowledge": JSON.stringify(updateUser),
                "event_id": eventId
            }, {}, false);
            await getEvent(getUser.user, dispatch, APP_NAME, activities);
        } catch (error) {
            console.log(error)
        }
    }
    // for adding extra field to default editor
    const editorTemplate = async (args) => {
        if (args.type === 'Editor') {
            let meetingUrl = ""
            if (state.employees.length > 0) {
                const employe = state.employees.filter(emp => emp.id === getUser.user.empId)
                meetingUrl = await updateTaskMeetingUrl(employe)
            }
            if (true) {
                let existingRow = args.element.querySelector('.custom-field-row');
                if (existingRow) {
                    existingRow.remove(); // Remove the existing row if it exists
                }
                let row = createElement('div', { className: 'custom-field-row' });
                let formElement = args.element.querySelector('.e-schedule-form');
                formElement.firstChild.insertBefore(row, formElement.firstChild.firstChild);
                //add attendees
                let container2 = createElement('div', { className: 'custom-field-container' });
                row.appendChild(container2);
                container2.style.marginBottom = "20px";
                let inputField2 = createElement('input', {
                    className: 'e-field', attrs: { name: 'Members' }
                });
                container2.appendChild(inputField2);
                let drowDownList2 = new MultiSelect({
                    dataSource: combinedEmpArray,
                    fields: { text: 'name', value: 'email' },
                    value: args.data.Members ? args.data.Members : [getUser.user.userName],
                    floatLabelType: 'Always', placeholder: 'Attendees',
                    mode: 'Box',
                    allowCustomValue: false, // Adjust as per your requirements
                    showClearButton: true,
                });
                drowDownList2.appendTo(inputField2);
                inputField2.setAttribute('name', 'Members');

                //location field
                let locationInput = args.element.querySelector('input[name="Location"]');
                locationInput.style.color = "red"
                locationInput.value = args.data.Location ? args.data.Location : meetingUrl;
                locationInput.style.cursor = "pointer"
                locationInput.readOnly = true;
            }
        } else if (args.type === 'QuickInfo') {
            if (args.data.acknowledge) {
                const acknowledgeData = JSON.parse(args.data.acknowledge)
                const modifyData = acknowledgeData?.map(item => {
                    let reasonAck = null
                    if (item.reason) {
                        reasonAck = item.reason
                    }
                    const index = employeeData.findIndex(user => user.email === item.email)
                    const name = employeeData[index].name
                    return { ...item, name: name, reason: reasonAck }
                })
                const userIndex = modifyData.findIndex(user => user.email === getUser.user.userName)
                const userResponse = modifyData[userIndex].ackStatus
                let row = document.createElement('div');
                row.classList.add('custom-field-row', 'pl-0');
                let eventPopup = document.querySelector('.e-event-popup');
                if (eventPopup) {
                    let content = eventPopup.querySelector('.e-popup-content');
                    if (content) {
                        content.insertBefore(row, content.firstChild);
                    }
                }
                let userReason
                let container = document.createElement('div');
                container.classList.add('custom-field-container', 'pl-0');
                let ul = document.createElement('ul');
                ul.style.maxHeight = '300px';
                ul.style.paddingLeft = '0px';
                ul.style.overflowY = 'auto';

                let li = document.createElement('li');
                li.classList.add('border-bottom', 'border-dark', 'mb-1')
                let ackDiv = document.createElement('div')
                ackDiv.classList.add('d-flex', 'justify-content-between', 'mb-2')
                let p1 = document.createElement('p')
                p1.textContent = userResponse === null ? 'Give your availabilty response' : 'You can change your availabilty response'
                p1.classList.add('fs-1', 'text-left')
                let div = document.createElement('div');
                div.classList.add('d-flex', 'justify-content-end', 'mb-2')
                let button1 = document.createElement('button');
                button1.textContent = 'Yes'
                button1.classList.add('btn', 'btn-success', 'mr-2')
                button1.addEventListener('click', function () {
                    submitResponse({ eventId: args.data.Id, acknowledgeData: modifyData, response: 'Accepted' })
                })
                ackDiv.appendChild(p1)
                ackDiv.appendChild(button1)
                let input = document.createElement('input')
                input.style.width = '250px';
                input.style.marginRight = '4px';
                input.style.border = '1px solid black';
                input.placeholder = 'Please enter your reason';
                input.addEventListener('input', function (e) {
                    userReason = e.target.value; // This will store the input value
                });
                let button2 = document.createElement('button');
                button2.textContent = 'May be'
                button2.classList.add('btn', 'btn-warning', 'mr-2')
                button2.addEventListener('click', function () {
                    if (!userReason) {
                        Alert('warning', "Please enter a reason");
                    } else {
                        submitResponse({ eventId: args.data.Id, acknowledgeData: modifyData, response: 'May be', reason: userReason })
                    }
                })
                let button3 = document.createElement('button');
                button3.textContent = 'No'
                button3.classList.add('btn', 'btn-danger')
                button3.addEventListener('click', function () {
                    if (!userReason) {
                        Alert('warning', "Please enter a reason");
                    } else {
                        submitResponse({ eventId: args.data.Id, acknowledgeData: modifyData, response: 'Denied', reason: userReason })
                    }
                })
                div.appendChild(input)
                div.appendChild(button2)
                div.appendChild(button3)
                li.appendChild(ackDiv)
                li.appendChild(div)
                ul.appendChild(li);
                modifyData.forEach(item => {
                    let li = document.createElement('li');
                    li.classList.add('d-flex', 'justify-content-between', 'mb-1', 'border-bottom', 'border-dark');
                    let p1 = document.createElement('p')
                    p1.textContent = `${item.name}`;
                    p1.classList.add('fs-1', 'text-left', 'fw-bold')
                    let smallDiv = document.createElement('div')
                    smallDiv.classList.add('d-flex' ,'flex-column','justify-content-end', 'align-items-end')
                    let button1 = document.createElement('p');
                    button1.classList.add('px-1', 'rounded-lg', item.ackStatus === null ? 'bg-warning' : item.ackStatus === 'Accepted' ? 'bg-success' : item.ackStatus === 'May be' ? 'bg-warning' : 'bg-danger');
                    button1.style.width= "fit-content";
                    button1.textContent = item.ackStatus === null ? 'No response' : item.ackStatus === 'Accepted' ? 'Accepted' : item.ackStatus === 'May be' ? 'May be' : 'Denied';
                    let reasonP = document.createElement('p')
                    reasonP.textContent = `${item.reason}`
                    smallDiv.appendChild(button1)
                    if (item.reason) {
                        smallDiv.appendChild(reasonP)
                    }
                    li.appendChild(p1)
                    li.appendChild(smallDiv)
                    ul.appendChild(li);
                });
                container.appendChild(ul);
                row.appendChild(container);
            }
        }
    }
    // for managing color for cart
    const onEventRendered = (args) => {
        if (args.data.IsAllDay === '1') {
            args.data.CategoryColor = '#1aaa55'
        } else if (args.data.EventStatus === "Cancel" && args.data.IsAllDay === '') {
            args.data.CategoryColor = '#F57F17'
            args.data.TextLine = 'line-through'
            args.data.LineColor = 'black'
        } else {
            args.data.CategoryColor = '#357CD2'
        }
        applyCategoryColor(args, scheduleObj.currentView);
    }
    const selectSprint = (selectedOption) => {
        getToDo(dispatch, getUser.user, selectedOption.moduleId);
    }

    // eslint-disable-next-line 
    const events = [...state.events].filter(val => {
        if (new Date(val.EndTime) >= new Date()) {
            return val
        }
    })

    // while searching any event
    const globalSearch = (args) => {
        let searchString = args.target.value;
        if (searchString !== '') {
            new DataManager(scheduleObj.current.eventsData).executeQuery(new Query().search(searchString, ['Subject', 'Location', 'Description'], null, true, true)).then((e) => {
                if (e.result.length > 0) {
                    showSearchEvents('show', e.result);
                }
                else {
                    showSearchEvents('hide');
                }
            });
        }
        else {
            showSearchEvents('hide');
        }
    }
    // for display searched results
    const showSearchEvents = (type, data) => {
        if (type === 'show') {
            if (document.getElementById('grid').classList.contains('e-grid')) {
                let gridObj = document.querySelector('#grid').ej2_instances[0];
                gridObj.dataSource = data;
                gridObj.dataBind();
            }
            else {
                let gridObj = new GridComponent({
                    dataSource: data,
                    height: 505,
                    width: 'auto',
                    columns: [
                        { field: 'Subject', headerText: 'Subject', width: 120 },
                        { field: 'Location', headerText: 'Location', width: 120 },
                        { field: 'StartTime', headerText: 'StartTime', width: 120, format: { type: 'dateTime', format: 'M/d/y hh:mm a' } },
                        { field: 'EndTime', headerText: 'EndTime', width: 120, format: { type: 'dateTime', format: 'M/d/y hh:mm a' } },
                    ]
                });
                gridObj.appendTo(document.querySelector('#grid'));
                // scheduleObj.element.style.display = 'none';
            }
        }
        else {
            let gridObj = document.querySelector('#grid').ej2_instances;
            if (gridObj && gridObj.length > 0 && !gridObj[0].isDestroyed) {
                gridObj[0].destroy();
            }
            // scheduleObj.element.style.display = 'block';
        }
    }
    return (

        <div className="container-scroller">
            <Header />
            <div className="container-fluid page-body-wrapper">
                <AdminSideBar />
                <div className="main-panel" >
                    <div className="mt-2">
                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row ">
                                        <div className="d-flex justify-content-between col-12 row m-1 ">
                                            <h2 className="card-title calender-ml" style={{ paddingTop: 20, paddingLeft: 20 }}>CALENDAR</h2>

                                            {/* <label className="p-2" >Sprints</label> */}

                                            <div className="d-flex justify-content-end mt-2 tnb">
                                                <div className='row'>
                                                    <div className="cal-ml " style={{ width: 250, marginRight: 10 }}>

                                                        {/* for selecting data sprint vise  */}
                                                        <Select
                                                            className="form-control calender-w "
                                                            style={{ width: 10, boarderRadius: 2, }}
                                                            // placeholder="Select Active Points"
                                                            maxMenuHeight={130}
                                                            placeholder={state.sprint.moduleDesc}
                                                            value={sprints.value}
                                                            onChange={(selectedOption) => {
                                                                selectSprint(selectedOption)
                                                            }
                                                            }
                                                            options={sprints}
                                                        />
                                                    </div>
                                                    <div className="input-group-prepend cal-w" id='input_block' style={{ marginTop: 5, display: 'flex', justifyContent: 'center' }}>
                                                        <h1 className="text" style={{ color: 'black', marginTop: '8px', fontSize: '13px' }}>Search:</h1>
                                                        <input type="text" className="form-control overflow-hidden mr-sm-2" size='50' style={{ backgroundColor: 'transparent', borderBottom: '2px solid black', borderTop: '2px solid', borderLeft: '2px solid black', borderRight: '2px solid black', width: 250, height: '35px' }}
                                                            onKeyUp={(args) => globalSearch(args)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {state.isLoading || state.fetching ?
                                            <>
                                                <RootLoader />
                                                <p style={{ textAlign: 'center', width: '100vw' }}>Data is updating; please don't navigate back from this page.</p>
                                            </> :
                                            <div>
                                                <div id="grid"></div>
                                                {/* all UI for calendar include in ScheduleComponent  */}
                                                <ScheduleComponent
                                                    height='700px'
                                                    ref={scheduleObj}
                                                    eventSettings={{ dataSource: events, fields: fields, editFollowingEvents: true }}
                                                    dataBinding={handleData}
                                                    popupOpen={editorTemplate}
                                                    group={{
                                                        allowGroupEdit: true
                                                        // for show members list and remove multiple meet column for multiple people
                                                        // , resources: ['Conferences'] 
                                                    }}
                                                    eventRendered={onEventRendered}
                                                >
                                                    {/* for adding Members */}
                                                    {/* <ResourcesDirective>
                                                        <ResourceDirective field='Members' title='Attendees' name='Conferences' allowMultiple={true}
                                                            //   dataSource={state.employees}
                                                            dataSource={combinedEmpArray}
                                                            textField='name' idField='email'>
                                                        </ResourceDirective>
                                                    </ResourcesDirective> */}
                                                    <Inject
                                                        services={[Day, Week, WorkWeek, Month, Agenda, DragAndDrop, Resize]} />
                                                </ScheduleComponent>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    );
}

export default Calender;